import React from "react";

export default function ShadeBackgound({ opacity, onClik, children }) {
  return (
    <div
      onClick={onClik}
      className={" bg-black z-10 absolute inset-0"}
      style={{ opacity: opacity }}
    >
      {children}
    </div>
  );
}
